import ProjectAgGridListComponent from "components/project-list-view/projectAgGridListComponent";

import "./projects-list.scss";
import dayjs from "utils/dayjs-config";

function ProjectList() {
  // Set user local timezone for project list page.
  dayjs.tz.setDefault(dayjs.tz.guess());
  return <ProjectAgGridListComponent />;
}

export default ProjectList;
